import React, { useEffect, useRef, useState } from "react";
import "./ServicesHero.css";

import img1 from "../../assets/images/services1.jpg";
import img2 from "../../assets/images/services2.jpg";
import img3 from "../../assets/images/services3.jpg";

const ServicesHero = () => {
  const contentRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);

  const images = [img1, img2, img3];

  // Reveal Animation
  useEffect(() => {
    const handleScroll = () => {
      if (!contentRef.current) return;

      const rect = contentRef.current.getBoundingClientRect();
      if (rect.top < window.innerHeight - 150) {
        contentRef.current.classList.add("show");
      }
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Carousel Auto Slide
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % images.length);
    }, 2000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="services-hero-section">

      {/* Background Carousel */}
      <div className="carousel-wrapper">
        {images.map((img, index) => (
          <div
            key={index}
            className={`carousel-image ${index === activeIndex ? "active" : ""}`}
            style={{ backgroundImage: `url(${img})` }}
          ></div>
        ))}
      </div>

      <div className="services-hero-overlay"></div>

      <div ref={contentRef} className="services-hero-content">
        <h1>Our Services</h1>
        <p>Empower Your Business, Embrace IT Excellence!</p>
      </div>
    </section>
  );
};

export default ServicesHero;
